<template>
  <div class="col col-lg-3 d-none d-xl-block">
    <div class="justify-end">
      <div>
        <img v-if="region === 'north-alabama'" src="/images/areas/north-alabama.svg" />
        <div v-else class="north-alabama-collapsed"></div>
      </div>
      <div>
        <img v-if="region === 'central-alabama'" src="/images/areas/central-alabama.svg" />
        <div v-else class="central-alabama-collapsed"></div>
      </div>
      <div>
        <img v-if="region === 'south-alabama'" src="/images/areas/south-alabama.svg" />
        <div v-else class="south-alabama-collapsed"></div>
      </div>
      <div>
        <img v-if="region === 'beaches-gulf-coast'" src="/images/areas/gulf-coast.svg" />
        <div v-else class="beaches-gulf-coast-collapsed"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';

// console.log(this.Region);
@Component({
  components: {},
  methods: {},
  mounted() {},
  computed: {},
})
class RegionIcon extends Vue {
  @Prop({ type: String })
  region;
}

export default RegionIcon;
</script>

<style lang="scss" scoped>
img {
  width: 106px;
  height: 106px;
  margin-bottom: 0.25em;
}
.justify-end {
  display: grid;
  justify-items: flex-end;
}
.north-alabama-collapsed {
  width: 106px;
  height: 12px;
  border-radius: 3px;
  border: 4px solid #36784e;
  background: #e4e3d2;
  margin-bottom: 0.25em;
}

.central-alabama-collapsed {
  width: 106px;
  height: 12px;
  border-radius: 3px;
  border: 4px solid #994427;
  background: #f6dfd7;
  margin-bottom: 0.25em;
}

.south-alabama-collapsed {
  width: 106px;
  height: 12px;
  border-radius: 3px;
  border: 4px solid #7d8446;
  background: #e0dbce;
  margin-bottom: 0.25em;
}

.beaches-gulf-coast-collapsed {
  width: 106px;
  height: 12px;
  border-radius: 3px;
  border: 4px solid #7fb4c8;
  background: #f8f8f1;
  margin-bottom: 0.25em;
}

@media only screen and (max-width: 768px) {
  .north-alabama,
  .central-alabama,
  .south-alabama,
  .beaches-gulf-coast {
    background-image: none;
  }

  .region-left {
    padding-left: 0px;
    padding-top: 0px;
  }
}

@media only screen and (max-width: 740px) {
  .north-alabama,
  .central-alabama,
  .south-alabama,
  .beaches-gulf-coast {
    background-position-x: 15px;
  }

  .region-left {
    padding-left: 15px;
    padding-right: 15px;
  }

  .region-right {
    position: inherit;
    border-left: none !important;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 0px;
  }
}
</style>
